import { useEffect, useRef } from 'react';
import { useFirmBaseLayoutContext } from './FirmBaseLayoutContext';
import type { FirmBaseLayoutNavigationRegistrationToken } from './FirmBaseLayoutContext.types';
import type { SecondaryNavigationState } from './secondaryNavigation.types';

export const useSecondaryNavigationRegistration = (secondaryNavigation: SecondaryNavigationState | null) => {
  // This is shell-state ownership, not a DOM id. Symbol prevents collisions and useRef keeps it stable per route instance.
  const registrationTokenRef = useRef<FirmBaseLayoutNavigationRegistrationToken>(Symbol('secondary-navigation'));
  const registrationToken = registrationTokenRef.current;
  const { clearSecondaryNavigation, registerSecondaryNavigation } = useFirmBaseLayoutContext();

  // Register secondary navigation for the active route child and only clear registrations owned by this route.
  useEffect(() => {
    registerSecondaryNavigation(registrationToken, secondaryNavigation);

    return () => {
      clearSecondaryNavigation(registrationToken);
    };
  }, [clearSecondaryNavigation, registerSecondaryNavigation, registrationToken, secondaryNavigation]);
};
